import { dynamicApiSlice } from "../dynamicApi";
import type { CompaniesHouseCompany } from "@/types/richInputComponents/CompaniesHouseCompany";

export const companiesHouseApi = dynamicApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    searchCompanies: builder.query<
      CompaniesHouseCompany[],
      { query: string; }
    >({
      query: ({ query }) =>
        `companies-house/company-search/${query}`,
      transformResponse: (response: CompaniesHouseCompany[]) => response,
    }),
  }),
  overrideExisting: false,
});

export const {
  useSearchCompaniesQuery
} = companiesHouseApi;
